<section id="dynamic-category-header-2345674" data-header-type="Category Header" class="dynamic-header-theme">
    <div class="equipo-header">
        <div class="header-content dynamic-header-background animated fadeIn" [hidden]="showMobileSearchPanel">
            @if (isMobile() && headerData.menuListVisibleOnMobile) {
            <div class="ham-icon-container only-mobile">
                <img class="ham-menu-icon" [src]="headerData.hamburgerMenuIcon" (click)="toggleHamburgerMenu()" />
            </div>
            }
            <!-- mobile logo icon -->
            @if (headerData.logo.isVisibleOnMobile && isMobile()) {
            <div class="logo-container">
                <a [routerLink]="['/']">
                    <img [src]="headerData.logo.logoSrc" class="static-header-logo home" />
                </a>
            </div>
            } @else {
            @if (headerData.logo.isVisibleOnDesktop && isDesktop()) {
            <div class="logo-container">
                <a [routerLink]="['/']">
                    <img [src]="headerData.logo.logoSrc" class="static-header-logo home" />
                </a>
            </div>
            }
            }

            <!-- desktop search icon -->
            @if (headerData.searchIcon.isVisibleOnDesktop && isDesktop()) {
            <base-search-bar class="only-desktop equipo-header-search" [selectedDeviceType]="deviceType()" [headerData]="headerData" (searchProduct$)="searchProduct($event)" [searchInputControl]="searchInputControl" (searchIconClick$)="searchIconClick()" [isFocused]="showMobileSearchPanel"></base-search-bar>
            }

            <ul class="icon-item-list">
                <!-- mobile account icon -->
                @if (headerData.accountIcon.isVisibleOnMobile && isMobile()) {
                <li>
                    <a (click)="isHamburgerMenu = false" [target]="headerData.accountIcon.target" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']">
                        <img class="account static-header-account-icon dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" [src]="headerData.accountIcon.accountIconSrc" />
                    </a>
                </li>
                } @else {
                @if (headerData.accountIcon.isVisibleOnDesktop && isDesktop()) {
                <li>
                    <a [target]="headerData.accountIcon.target" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']">
                        <img class="account static-header-account-icon dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" [src]="headerData.accountIcon.accountIconSrc" />
                    </a>
                </li>
                }
                }

                <!-- mobile cart icon -->
                @if (headerData.cartIcon.isVisibleOnMobile && isMobile()) {
                <li (click)="isHamburgerMenu = false">
                    <div class="cart-item-count dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">
                        {{ cart.cart_items.length }}
                    </div>
                    <a class="cart static-header-cart-icon" [target]="headerData.cartIcon.target" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']">
                        <img [src]="headerData.cartIcon.cartIconSrc" class="dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" />
                    </a>
                </li>
                } @else {
                @if (headerData.cartIcon.isVisibleOnDesktop && isDesktop()) {
                <li>
                    <div class="cart-item-count dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">
                        {{ cart.cart_items.length }}
                    </div>
                    <a class="cart static-header-cart-icon" [target]="headerData.cartIcon.target" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']">
                        <img [src]="headerData.cartIcon.cartIconSrc" class="dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" />
                    </a>
                </li>
                }
                }
                <!-- mobile store-locator icon -->
                @if (headerData.storeLocationDesktop.isVisibleOnMobile && isMobile()) {
                <li class="only-desktop">
                    <a class="store-locator static-header-logout-icon" [target]="headerData.storeLocationDesktop.target" [attr.data-click_action_value]="headerData.storeLocationDesktop['data-click_action_value']" [attr.data-click_action_choice]="headerData.storeLocationDesktop['data-click_action_choice']">
                        <img [src]="headerData.storeLocationDesktop.storeLocationDesktopSrc" class="dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" />
                    </a>
                </li>
                } @else {
                @if (headerData.storeLocationDesktop.isVisibleOnDesktop && isDesktop()) {
                <li class="only-desktop">
                    <a class="store-locator static-header-logout-icon" [target]="headerData.storeLocationDesktop.target" [attr.data-click_action_value]="headerData.storeLocationDesktop['data-click_action_value']" [attr.data-click_action_choice]="headerData.storeLocationDesktop['data-click_action_choice']">
                        <img [src]="headerData.storeLocationDesktop.storeLocationDesktopSrc" class="dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" />
                    </a>
                </li>
                }
                }

                <!-- mobile search icon -->
                @if (headerData.searchIconMobile.isVisibleOnMobile && isMobile()) {
                <li class="only-mobile">
                    <a class="mobile-search static-header-search-icon-mobile" (click)="toggleSearchDropDown()">
                        <img [src]="headerData.searchIconMobile.searchIconMobileSrc" class="dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" />
                    </a>
                </li>
                }
            </ul>
        </div>

        @if (showMobileSearchPanel) {
        <div class="mobile-search-panel dynamic-header-background">
            <base-search-bar class="equipo-header-search" [selectedDeviceType]="deviceType()" [headerData]="headerData" (searchProduct$)="searchProduct($event)" [searchInputControl]="searchInputControl" (searchIconClick$)="searchIconClick()" [isFocused]="showMobileSearchPanel"></base-search-bar>
            <img [src]="headerData.closeIcon" class="search-mobile-close-icon" (click)="toggleSearchDropDown()" />
        </div>
        }
    </div>
    <div class="layout-1" #changeHeaderElement>
        <nav class="mega-menu-category dynamic-header-background">
            @if (headerData.menuListVisibleOnDesktop) {
            <div class="only-desktop">
                <ul class="dynamic-menu-alignment">
                    @for (staticMenu of headerData.menuItems; track staticMenu) {
                    @if (staticMenu.text !== 'Category Header') {
                    <li class="static-menu">
                        <a [ngClass]="{
                      'hover-color-active': showActiveColor && currentMenuId === staticMenu.id,
                      'hover-color-inactive': !showActiveColor && currentMenuId === staticMenu.id,
                    }" [id]="staticMenu.id" (click)="onLinkClick()" class="static-header dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu" [target]="staticMenu.target" [attr.data-click_action_value]="staticMenu['data-click_action_value']" [attr.data-click_action_choice]="staticMenu['data-click_action_choice']">{{ staticMenu.text }}</a>
                        @if (staticMenu?.subMenu?.length) {
                        <ul (mouseenter)="showActiveColor = true; currentMenuId = staticMenu.id" (mouseleave)="removeHoverStyle()" class="dynamic-sub-menu-background hide-sub-menu-header">
                            @for (subMenu of staticMenu.subMenu; track subMenu) {
                            <li>
                                <a [target]="subMenu.target" (click)="onLinkClick()" [attr.data-click_action_value]="subMenu['data-click_action_value']" [attr.data-click_action_choice]="subMenu['data-click_action_choice']" class="dynamic-font-size-sub-menu dynamic-font-weight-sub-menu dynamic-header-sub-menu-text-color hoverSubMenu">{{ subMenu.text }}</a>
                                @if (subMenu?.subMenu?.length) {
                                <ul>
                                    @for (subSubMenu of subMenu.subMenu; track subSubMenu) {
                                    <li class="dynamic-sub-menu-background">
                                        <a [target]="subSubMenu.target" (click)="onLinkClick()" [attr.data-click_action_value]="subSubMenu['data-click_action_value']" [attr.data-click_action_choice]="subSubMenu['data-click_action_choice']" class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu">{{ subSubMenu.text }}</a>
                                    </li>
                                    }
                                </ul>
                                }
                            </li>
                            }
                        </ul>
                        }
                    </li>
                    }
                    }

                    <div #dynamicCategoryHeader>
                        <!-- This is for inline type header menu -->
                        @if (dynamicHeaderInline() && layoutType === 'inlineLayout1') {
                        @for (parentCategory of category; track parentCategory; let i = $index) {
                        <li>
                            <a [routerLink]="'category/' + parentCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: parentCategory.url_path }" (click)="onLinkClick()" class="dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color hoverMenu" [ngClass]="{
                        'hover-color-active': showActiveColor && currentMenuId === parentCategory.id,
                        'hover-color-inactive': !showActiveColor && currentMenuId === parentCategory.id,
                      }">{{ parentCategory.name }}</a>

                            @if (parentCategory.sub_categories.length) {
                            <ul (mouseenter)="showActiveColor = true; currentMenuId = parentCategory.id" (mouseleave)="removeHoverStyle()" class="dynamic-sub-menu-background hide-sub-menu-header">
                                @for (childCategory of parentCategory.sub_categories; track childCategory) {
                                <li>
                                    <a [routerLink]="'category/' + childCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: childCategory.url_path }" (click)="onLinkClick()" class="dynamic-font-size-sub-menu dynamic-font-weight-sub-menu dynamic-header-sub-menu-text-color hoverSubMenu">{{ childCategory.name }}</a>
                                    @if (childCategory.sub_categories.length) {
                                    <ul>
                                        @for (subCategory of childCategory.sub_categories; track subCategory) {
                                        <li class="dynamic-sub-menu-background">
                                            <a [routerLink]="'category/' + subCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: subCategory.url_path }" (click)="onLinkClick()" class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu">{{ subCategory.name }}</a>
                                        </li>
                                        }
                                    </ul>
                                    }
                                </li>
                                }
                            </ul>
                            }
                        </li>
                        }
                        }

                        <!-- hover based header menu -->
                        @if (dynamicHeaderHover() && layoutType === 'hoverLayout1') {
                        <li>
                            <a (click)="onLinkClick()" class="category-menu-name dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color hoverMenu">{{ headerData.categoryMenuName }}</a>

                            @if (category) {
                            <ul class="dynamic-sub-menu-background hide-sub-menu-header">
                                @for (parentCategory of category; track parentCategory; let i = $index) {
                                <li>
                                    <a [routerLink]="'category/' + parentCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: parentCategory.url_path }" (click)="onLinkClick()" class="dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu" [ngClass]="{
                              'hover-color-active': showActiveColor && currentMenuId === parentCategory.id,
                              'hover-color-inactive': !showActiveColor && currentMenuId === parentCategory.id,
                            }">{{ parentCategory.name }}</a>

                                    @if (parentCategory.sub_categories.length) {
                                    <ul (mouseenter)="showActiveColor = true; currentMenuId = parentCategory.id" (mouseleave)="removeHoverStyle()">
                                        @for (childCategory of parentCategory.sub_categories; track childCategory) {
                                        <li class="dynamic-sub-menu-background">
                                            <a [routerLink]="'category/' + childCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: childCategory.url_path }" (click)="onLinkClick()" class="dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu">{{ childCategory.name }}</a>

                                            @if (childCategory.sub_categories.length) {
                                            <ul>
                                                @for (subCategory of childCategory.sub_categories; track subCategory) {
                                                <li class="dynamic-sub-menu-background">
                                                    <a [routerLink]="'category/' + subCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: subCategory.url_path }" (click)="onLinkClick()" class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu">
                                                        {{ subCategory.name }}</a>
                                                </li>
                                                }
                                            </ul>
                                            }
                                        </li>
                                        }
                                    </ul>
                                    }
                                </li>
                                }
                            </ul>
                            }
                        </li>
                        }
                    </div>
                </ul>
            </div>
            }
        </nav>
    </div>
</section>

<!-- do not touch -->
@if (isHamburgerMenu) {
<div appClickOutside #changeHeaderMobileElement class="mobile-subcategory-list animated fadeInLeft mobile-category-panel">
    <static-menu-collapse (hideMenu$)="toggleHamburgerMenu()" [headerData]="headerData"> </static-menu-collapse>

    @if (
    (dynamicHeaderInline() && layoutType === 'inlineLayout1') ||
    (dynamicHeaderHover() && layoutType === 'hoverLayout1')
    ) {
    <webstore-dynamic-menu-collapse #dynamicCategoryHeaderMobile [categories]="category || []" [menuCollapseIcon]="headerData.menuCollapseIcon" (hideMenu$)="toggleHamburgerMenu()">
    </webstore-dynamic-menu-collapse>
    }
</div>
}